import { useNavigate, useSearchParams } from "react-router-dom";
import { Camera, MessageCircle, ChevronRight, ScanLine } from "lucide-react";
import { Shell, TopBar } from "../components/Shell";

export default function Mode() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sid = params.get("sid");

  const cards = [
    {
      testid: "mode-capture",
      icon: Camera,
      title: "AI intraoral photo scan",
      badge: "Recommended",
      desc: "Take six guided photos of your teeth — or upload ones you already have — for an AI screening.",
      to: `/capture?sid=${sid}&step=0`,
    },
    {
      testid: "mode-xray",
      icon: ScanLine,
      title: "AI IOPA / OPG scan",
      desc: "Upload a dental X-ray, IOPA or OPG and get AI-highlighted regions with educational notes (not a diagnosis).",
      to: `/xray`,
    },
    {
      testid: "mode-chat",
      icon: MessageCircle,
      title: "Ask DentaFriend",
      desc: "Skip photos and chat about your concern instead.",
      to: `/chat?sid=${sid}`,
    },
  ];

  return (
    <Shell header={<TopBar title="Choose how to continue" />}>
      <div className="px-6 py-5 flex flex-col gap-4">
        <p className="text-sm text-muted-foreground">
          Nothing here is compulsory — pick whatever suits you.
        </p>
        {cards.map((c) => (
          <button key={c.testid} data-testid={c.testid} onClick={() => navigate(c.to)}
            className="tap flex items-start gap-4 rounded-2xl border border-border bg-card p-5 text-left card-elev">
            <div className="w-12 h-12 rounded-2xl bg-accent flex items-center justify-center shrink-0">
              <c.icon className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <p className="font-head font-semibold text-[15px]">{c.title}</p>
                {c.badge && (
                  <span className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-primary text-primary-foreground">{c.badge}</span>
                )}
              </div>
              <p className="text-[13px] text-muted-foreground mt-0.5 leading-snug">{c.desc}</p>
            </div>
            <ChevronRight className="w-5 h-5 text-muted-foreground mt-1" />
          </button>
        ))}

        <button data-testid="mode-upload-link" onClick={() => navigate(`/upload?sid=${sid}`)}
          className="tap self-center mt-1 text-[13px] font-semibold text-primary underline underline-offset-2">
          Already have your teeth photos? Upload them instead
        </button>
      </div>
    </Shell>
  );
}
